export const scrollReachedBottom = (scrollableContainerRef, offset=100) => (
  scrollableContainerRef.scrollTop >= scrollableContainerRef.scrollHeight - scrollableContainerRef.clientHeight - offset
)

export const getScrollBottom = (scrollableContainerRef) => (
  scrollableContainerRef.scrollHeight
  - scrollableContainerRef.clientHeight
  - scrollableContainerRef.scrollTop
)